<template>
  <div>
    <LazyHydrate when-idle>
      <BaseTopCard :details="topCardDetails" isWhiteBg />
    </LazyHydrate>

    <LazyHydrate when-visible>
      <div
        class="gridClass flex flex-col laptop:flex-row gap-5 items-center justify-between my-16"
      >
        <SectionSupportCard
          :data="item"
          v-for="item in dataSuport"
          :key="item.id"
        />
      </div>
    </LazyHydrate>
    <div class="gridClass my-16 flex flex-col items-center">
      <h2 class="mb-6 font-bold text-xl">فرم صدای مشتری</h2>
      <div class="w-full">
        <div class="p-10 bg-blue-450 bg-opacity-5 w-full rounded-xl">
          <Form
            class="w-full"
            :validation-schema="schema"
            :initial-values="initialValues"
            @submit="handleSubmit"
          >
            <div
              class="flex items-center justify-between w-full laptop:[&>*]:w-[48%] flex-wrap"
            >
              <BaseInput name="name" placeholder="نام و نام خانوادگی" />
              <BaseInput name="number" placeholder="شماره موبایل" isNumber />
            </div>
            <BaseInputTextarea name="text" placeholder="متن پیام" />
            <BaseButton size="full" type="submit" text="ارسال درخواست" />
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { object, string } from "yup";
import { Form } from "vee-validate";
const { validateFaChar, validateMobile } = useInputHelpers();

const { post, loading } = useSendMail();

const successModalButton = ref();

const topCardDetails = {
  title: "پشتیبانی ۲۴ ساعته نواتل",
  desc: `ضمن تشکر از اینکه مرکز تلفن ابری نواتل را برای سیستم ارتباطی خود انتخاب کرده‌اید، به اطلاع می‌رسانیم شما می‌توانید در هر زمان از شبانه‌روز  علاوه‌بر تماس مستقیم با شماره 02182800000، از روش‌های زیر با بخش‌های مختلف ما ارتباط برقرار کرده و امور موردنظر خود را پیگیری کنید.`,
  img: "/img/suport.webp",
}
const dataSuport = [
  {
    id: 1,
    title: "فروش",
    icon: "95",
    email: "sales@navatel.ir",
  },
  {
    id: 2,
    title: "پشتیبانی",
    icon: "93",
    email: "support@navatel.ir",
  },
  {
    id: 3,
    title: "مالی",
    icon: "97",
    email: "finance@navatel.ir",
  },
  {
    id: 4,
    title: "مدیریت",
    icon: "13",
    email: "manager@navatel.ir",
  },
  {
    id: 5,
    title: "روابط عمومی",
    icon: "94",
    email: "office@sgas.ir",
  },
];

const initialValues = {
  name: "",
  number: "",
  text: "",
};
const schema = object({
  name: string()
    .required("این فیلد نباید خالی باشد.")
    .test("", "مقدار وارد شده معتبر نیست.", validateFaChar),
  number: string()
    .required("این فیلد نباید خالی باشد.")
    .test("", "مقدار وارد شده معتبر نیست.", validateMobile),
  text: string().required("این فیلد نباید خالی باشد."),
});
const handleSubmit = async (form, { resetForm }) => {
  if (!loading.value) {
    form.action = "sendmail_support";
    const { data, error } = await post({
      body: { model: form },
    });

    if (!error.value && data.value === "ok") {
      resetForm();
      successModalButton.value.click();
    }
  }
}
useHead({

   link: [
    {
      rel: 'canonical',
      href: "https://navatel.ir/support/"
    }
  ]
})
</script>
